import React, { FC } from 'react'
import { Element } from './Element'

interface SurfaceProps {
  variant?: string
}

export const Surface: FC<SurfaceProps> = ({ children, variant }) => {
  return (
    <Element component='Surface' variant={variant}>
      {children}
    </Element>
  )
}
